import { render, staticRenderFns } from "./tag-group.vue?vue&type=template&id=62a890ae&scoped=true"
import script from "./tag-group.vue?vue&type=script&lang=js"
export * from "./tag-group.vue?vue&type=script&lang=js"
import style0 from "./tag-group.vue?vue&type=style&index=0&id=62a890ae&prod&lang=scss&scoped=true"
import style1 from "./tag-group.vue?vue&type=style&index=1&id=62a890ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a890ae",
  null
  
)

export default component.exports